import { render, staticRenderFns } from "./OptionInterface.vue?vue&type=template&id=223a5a90&scoped=true&"
import script from "./OptionInterface.vue?vue&type=script&lang=js&"
export * from "./OptionInterface.vue?vue&type=script&lang=js&"
import style0 from "./OptionInterface.vue?vue&type=style&index=0&id=223a5a90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223a5a90",
  null
  
)

export default component.exports